import React from "react";
import { createPortal } from "react-dom";

const AlertModal = ({
    isOpen,
    title = "Alert!",
    message = "Something went wrong.",
    buttonText = "OK",
    onClose,
    action
}) => {
    if (!isOpen) return null;

    return createPortal(
      (
      <div className="confirm-modal-backdrop" style={{ zIndex: 1000000000000 }}>
        <div className="confirm-modal-container">
          <h2 className="confirm-modal-title" style={{ textAlign: "left" }}>
            {title}
          </h2>

          {/* Centered Trash Icon */}
          {action === 'Delete' && (
            <div className="text-center mb-3" style={{ minHeight: '60px' }}>
              {action === 'Delete' && (
                <div className="text-center mb-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="60"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#e53935"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="3 6 5 6 21 6" />
                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m5 0V4a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2v2" />
                  </svg>
                </div>
              )}
            </div>
          )}

          <p className="confirm-modal-message text-start" style={{ textAlign: "left" }}>
            {message}
          </p>

          <div className="confirm-modal-buttons d-flex flex-column gap-2">
            <button
              onClick={onClose}
              className="confirm-modal-btn confirm-btn w-100"
              style={{
                backgroundColor: "#D90F21",
                borderColor: "#D90F21",
                color: "#fff",
              }}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
      ),
      document.body,
    );
};

export default AlertModal;
